import Notify from '@/services/notify'
import i18n from '@/lang/i18n'

let blocked = false
let dismissNotification = null

const hideNotification = () => {
    if (typeof dismissNotification === 'function') {
        dismissNotification()
    }
    dismissNotification = null
}

export const isSessionBlocked = () => blocked

export const clearSessionExpired = () => {
    blocked = false
    hideNotification()
}

export const activateSessionExpired = ({ onRelogin } = {}) => {
    blocked = true

    // Keep one persistent notification visible until user action.
    if (dismissNotification) return

    const message = i18n.global.t('error.sessionExpired.text')
    const reloginLabel = i18n.global.t('error.sessionExpired.action')

    dismissNotification = Notify.create({
        message,
        color: 'warning',
        icon: 'sym_o_login',
        timeout: 0,
        multiLine: true,
        actions: [{
            label: reloginLabel,
            color: 'white',
            handler: () => {
                hideNotification()
                if (typeof onRelogin === 'function') onRelogin()
            },
        }],
    })
}

export default {
    isSessionBlocked,
    clearSessionExpired,
    activateSessionExpired,
}